import { render, staticRenderFns } from "./ShoppingInformations.vue?vue&type=template&id=1afcda20&scoped=true&"
import script from "./ShoppingInformations.vue?vue&type=script&lang=js&"
export * from "./ShoppingInformations.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingInformations.vue?vue&type=style&index=0&id=1afcda20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcda20",
  null
  
)

export default component.exports